/*
 * 报价管理
 */

import EmptyRouter from '@/layout/EmptyRouter.vue';
import EmptyRouterAlive from '@/layout/EmptyRouterAlive.vue';

export default {
    path: 'customer',
    name: 'customerMenu',
    component: EmptyRouterAlive,
    meta: {
      title: 'customer',
    },
    children: [
      {
        path: 'Dashboard',
        name: 'onboardingDashboard',
        component: EmptyRouter,
        redirect: 'dashboard/index',
        meta: {
          title: '入场客户面板',
        },
        children: [
          {
            path: 'index',
            name: 'onboardingDashboard',
            component: () => import('@/views/center-business/customer/dashboard/index'),
            meta: {
              title: '入场客户面板',
              isCache: true,
            },
          },
        ],
      },
      {
        path: 'onboarding',
        name: 'onboardingPageIndex',
        component: EmptyRouter,
        redirect: 'onboarding/index',
        meta: {
          title: '入场客户',
        },
        children: [
          {
            path: 'index',
            name: 'onboardingPageIndex',
            component: () => import('@/views/center-business/customer/onboarding/index'),
            meta: {
              title: '入场客户',
              isCache: true,
            },
          },
        ],
      },
      {
        path: 'account',
        name: 'BusinessUserCustomerCSG',
        component: EmptyRouter,
        redirect: 'account/index',
        meta: { title: '客户管理', isCache: true },
        children: [
          {
            path: 'index',
            name: 'BusinessUserCustomerCSG',
            component: () => import('@/views/center-business/user/customerCSG/index'),
            meta: { title: '客户管理', isCache: true },
          },
          {
            path: 'add',
            name: 'BusinessUserCustomerAddCSG',
            component: () => import('@/views/center-business/user/customerCSG/add'),
            meta: { title: '新建客户', isCache: true},
          },
          {
            path: 'edit',
            name: 'BusinessUserCustomerEditCSG',
            component: () => import('@/views/center-business/user/customerCSG/edit'),
            meta: { title: '编辑客户'},
          },
        ],
      },
      {
        path: 'backup',
        name: 'BusinessUserDepartmentBackup',
        component: EmptyRouter,
        redirect: 'backup/index',
        meta: { title: '客户文件', isCache: true },
        children: [
          {
            path: 'index',
            name: 'BusinessUserDepartmentBackup',
            component: () => import('@/views/center-business/user/backup/index'),
            meta: { title: '客户文件', isCache: true },
          },
          {
            path: 'detail',
            name: 'BusinessUserDepartmentBackupDetail',
            component: () => import('@/views/center-business/user/backup/detail'),
            meta: { title: '客户文件详情', isCache: true },
          },
        ],
      },
    // {
    //   path: 'sortingStation',
    //   name: 'WMSSortingStation',
    //   component: EmptyRouter,
    //   redirect: 'sortingStation/index',
    //   meta: {
    //     title: '分拣台列表',
    //   },
    //   children: [
    //      {
    //       path: 'index',
    //       name: 'WMSSortingStation',
    //       component: () => import('@/views/center-business/WMS/sortingStation'),
    //       meta: {
    //         title: '分拣台列表',
    //         isCache: true,
    //       },
    //     },
    //   ],
    // },
    // {
    //   path: 'LampRack',
    //   name: 'WMSLampRack',
    //   component: EmptyRouter,
    //   redirect: 'LampRack/index',
    //   meta: {
    //     title: '灯架配置',
    //   },
    //   children: [
    //      {
    //       path: 'index',
    //       name: 'WMSLampRack',
    //       component: () => import('@/views/center-business/WMS/LampRack'),
    //       meta: {
    //         title: '灯架配置',
    //         isCache: true,
    //       },
    //     },
    //   ],
    // },
  ],
};
